export default {
    additionalProducts: [],
    paymentTypesPreDefinition: {
        cheque: 'Cheque',
        debito: 'Débito',
        debito_bb: 'Débito Banco do Brasil',
        carne: 'Carnê',
        credito: 'Crédito'
    }
}


// WEBPACK FOOTER //
// ./src/shared/helpers/vuex/result/state.js